import axios from "axios";

/*
=========================================================
AXIOS INSTANCE CONFIGURATION
=========================================================

Central API client used across the entire frontend.

Benefits:
- Single base URL configuration
- Automatic JSON headers
- Easy token management
- Centralized error handling
- Cleaner API calls in components

Example usage:
api.get("core/")
api.get("gallery/")
api.post("contact/")
=========================================================
*/


// ======================================================
// BASE URL
// Uses .env if available, otherwise fallback to live URL
// ======================================================
const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://srvjvss.org/api/";


// ======================================================
// CREATE AXIOS INSTANCE
// ======================================================
const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});


// ======================================================
// REQUEST INTERCEPTOR
// Automatically attach JWT token if available
// ======================================================
api.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("access_token");

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.warn("Token read error:", error);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// ======================================================
// RESPONSE INTERCEPTOR
// Global API error handling
// ======================================================
api.interceptors.response.use(
  (response) => response,

  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      console.error("API Error:", data);

      switch (status) {
        case 401:
          console.warn("Unauthorized request.");
          break;

        case 403:
          console.warn("Forbidden request.");
          break;

        case 404:
          console.warn("API endpoint not found.");
          break;

        case 500:
          console.error("Server error occurred.");
          break;

        default:
          console.warn("Unexpected API error.");
      }

    } else if (error.request) {
      console.error("Network error: server not reachable.");
    } else {
      console.error("Axios error:", error.message);
    }

    return Promise.reject(error);
  }
);


// ======================================================
// EXPORT API CLIENT
// ======================================================
export default api;